import {defineStore} from "pinia";
import {orderBy} from 'lodash'
import {useLocalStorage} from "@vueuse/core";
import {Favorite} from "~/models/favorites";


export const useAssortmentsStore = defineStore('assortments', () => {
  // Unordered - use favoriteAssortments instead in components
  const favorites = useLocalStorage('favoriteAssortments', [] as Array<Favorite>)
  const favoriteAssortments = computed((): Favorite[] => orderBy(favorites.value, 'count', 'desc').slice(0, 10))

  const clearFavoriteAssortments = (): void => {
    favorites.value = []
  }

  const addToFavorites = (id: string): void => {
    const existing = favorites.value.find((x: Favorite) => x.id === id)
    if (existing) {
      favorites.value[favorites.value.indexOf(existing)].count++
    } else {
      favorites.value.push({
        id,
        count: 1
      })
    }
  }

  return {
    favorites,
    favoriteAssortments,
    clearFavoriteAssortments,
    addToFavorites,
  }
})